<template>
  <div class="w-full h-full">
    <div class="relative w-full h-[400px] sm:h-[500px] md:h-[600px] lg:h-[800px]">
      <video
        ref="videoRef"
        src="../../assets/img/xr_jz.mp4"
        autoplay
        loop
        muted
        class="w-full h-full object-cover z-0"
        @loadedmetadata="skipFirstSecond"
      />
      <div class="absolute bottom-4 sm:bottom-8 md:bottom-[49px] left-0 right-0 w-full h-full z-10 flex flex-col items-center justify-end px-4">
        <div class="text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-[96px] font-black text-center leading-none m-0">
          XR家装
        </div>
        <div class="text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-[72px] font-black text-center leading-none m-0">
          XR HOME DECORATION
        </div>
        <div class="text-white text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-[36px] font-[w400] text-center leading-none m-0 z-20">
          LBE大空间
        </div>
        <div class="h-2 sm:h-3 md:h-4 lg:h-[17px] w-full max-w-[300px] sm:max-w-[500px] md:max-w-[800px] lg:max-w-[1199px] bg-[#0BE0BB] rounded-2xl -mt-2 sm:-mt-3 md:-mt-[12px]"></div>
      </div>
    </div>
    <div class="scenario-adaptation bg-[#0C3D8E] w-full py-8 sm:py-12 md:py-16 lg:py-20">
      <img
        src="../../assets/img/ywjs.webp"
        alt="scenario"
        class="mx-auto mb-6 sm:mb-8 md:mb-10 lg:mb-[46px] w-full max-w-[100px] sm:max-w-[122px] md:max-w-[144px] lg:max-w-[265px]"
      />
      <div class="sm:px-6 md:px-8">
        <!-- 标题区域 -->
        <div class="flex flex-col items-center justify-center text-center mb-8 sm:mb-12 md:mb-16 lg:mb-[68px]">
          <p class="text-white text-sm sm:text-[12px] md:text-[16px] lg:text-[20px] leading-relaxed max-w-[1300px] px-4 scroll-fade-in">
            数字化时代的到来为家装行业带来了前所未有的机遇。<br class="hidden sm:block" />
            大数据技术可以帮助企业深入了解消费者的需求和偏好，从而提供更精准的产品和服务。人工智能技术能够实现智能化设计<br class="hidden sm:block" />
            和施工管理，提高工作效率和质量。云计算技术则为数据存储和共享提供了便利，促进了企业内部和产业链上下游之间
          </p>
        </div>

        <!-- 内容区域 -->
        <div class="flex flex-col gap-6 sm:gap-8 md:gap-12">
          <!-- 第一个：精准化设计 - 图左文右 -->
          <div class="flex flex-col md:flex-row items-stretch relative">
            <!-- 左侧：图片（标题叠加在图片上） -->
            <div class="w-full md:flex-5 md:min-w-[400px] scroll-fade-in-left relative">
              <img
                src="../../assets/img/jz_1.webp"
                alt="vr"
                class="w-full h-[250px] sm:h-[300px] md:h-[400px] lg:h-[678px] object-cover transition-transform duration-1000 ease-in-out hover:scale-105"
              />
              <!-- 标题叠加在图片上 - 移动端显示在图片底部 -->
              <div
                class="absolute bottom-4 left-4 md:top-[103px] md:bottom-auto md:ml-[88%] z-20 scroll-fade-in w-[calc(100%-2rem)] md:w-[391px] "
                style="background: linear-gradient(to right, #1D76D0 0%, rgba(29, 114, 205, 0) 100%);
                   padding: 7px 0px 5px 31px; border-radius: 46px;"
              >
                <div class="flex items-center gap-3 mb-[3px]">
                  <h3 class="text-white text-2xl sm:text-3xl md:text-3xl lg:text-4xl font-bold">
                    精准化设计
                  </h3>
                </div>
                <div class="text-white/90 text-sm sm:text-base md:text-2xl lg:text-2xl">
                  PRECISE DESIGN
                </div>
              </div>

            </div>
            <!-- 右侧：深蓝色遮罩层（只有描述文字） -->
            <div class="w-full md:flex-4 md:min-w-[400px] flex-col scroll-fade-in rounded-lg p-6 sm:p-8 flex items-start md:items-end justify-center">

              <div class="w-[51px] h-3 bg-[#10b981] rounded-[51px] mb-6 sm:mb-8 md:mb-[50px]"></div>
              <p class="text-white text-base sm:text-[12px] md:text-[16px] lg:text-[20px] leading-relaxed">
                通过数字化技术，设计师可以更精准地把握客户需求，利用3D建模软件进行可视化设计，使设计方案更加直观、立体，减少了设计过程中的误差和反复修改的时间，从而提高了设计的精准度和效率。
              </p>

            </div>
          </div>
          <!-- 第二个：优化供应链 - 图右文左 -->
          <div class="flex flex-col md:flex-row items-stretch relative md:-mt-[6%] scroll-fade-in-right">
            <!-- 左侧：深蓝色遮罩层（只有描述文字） -->
            <div class="w-full md:flex-4 md:min-w-[400px] scroll-fade-in flex-col rounded-lg p-6 sm:p-8 flex items-start order-2 md:order-1 justify-center">

              <div class="w-[51px] h-3 bg-[#10b981] rounded-[51px] mb-6 sm:mb-8 md:mb-[50px]"></div>
              <p class="text-white text-base sm:text-[12px] md:text-[16px] lg:text-[20px] leading-relaxed">
                数字化技术可以实现供应链的智能化管理，通过数据分析预测市场需求，优化库存管理，减少库存积压，提高物流效率，从而降低成本，提升供应链的整体运营效率。
              </p>
            </div>
            <!-- 右侧：图片（标题叠加在图片上） -->
            <div class="w-full md:flex-5 md:min-w-[400px] scroll-fade-in relative order-1 md:order-2">
              <img
                src="../../assets/img/jz_2.webp"
                alt="lbe"
                class="w-full h-[250px] sm:h-[300px] md:h-[400px] lg:h-[678px] object-cover transition-transform duration-1000 ease-in-out hover:scale-105"
              />
              <!-- 标题叠加在图片上 - 移动端显示在图片底部 -->
              <div
                class="absolute bottom-4 left-4 md:top-[103px] md:bottom-auto md:ml-[-16%] z-20 scroll-fade-in w-[calc(100%-2rem)] md:w-[391px] "
                style="background: linear-gradient(to right, #1D76D0 0%, rgba(29, 114, 205, 0) 100%);
                   padding: 7px 0px 5px 31px; border-radius: 46px;"
              >
                <div class="flex items-center gap-3 mb-[3px]">
                  <h3 class="text-white text-2xl sm:text-3xl md:text-2xl lg:text-4xl font-bold">
                    优化供应链
                  </h3>
                </div>
                <div class="text-white/90 text-sm sm:text-base md:text-[20px] lg:text-[24px]">
                  OPTIMIZE THE SUPPLY CHAIN
                </div>
              </div>
            </div>
          </div>

          <!-- 第三个：提高施工质量 - 图左文右 -->
          <div class="flex flex-col md:flex-row items-stretch relative md:-mt-[6%] scroll-fade-in-left">
            <!-- 左侧：图片（标题叠加在图片上） -->
            <div class="w-full md:flex-5 md:min-w-[400px] scroll-fade-in relative">
              <img
                src="../../assets/img/jz_3.webp"
                alt="theme"
                class="w-full h-[250px] sm:h-[300px] md:h-[400px] lg:h-[678px] object-cover transition-transform duration-1000 ease-in-out hover:scale-105"
              />
              <!-- 标题叠加在图片上 - 移动端显示在图片底部 -->
              <div
                class="absolute bottom-4 left-4 md:top-[103px] md:bottom-auto md:left-[90%] md:right-auto w-[calc(100%-2rem)] md:w-[450px] z-20 scroll-fade-in"
                style="background: linear-gradient(to right, #1D76D0 0%, rgba(29, 114, 205, 0) 100%);
                   padding: 7px 0px 5px 31px; border-radius: 46px;"
              >
                <div class="flex items-center gap-3 mb-[3px]">
                  <h3 class="text-white text-2xl sm:text-3xl md:text-2xl lg:text-4xl font-bold">
                    提高施工质量
                  </h3>
                </div>
                <div class="text-white/90 text-sm sm:text-base md:text-[20px] lg:text-[24px]">
                  IMPROVE CONSTRUCTION QUALITY
                </div>
              </div>
            </div>
            <!-- 右侧：深蓝色遮罩层（只有描述文字） -->
            <div class="w-full md:flex-4 md:min-w-[400px] scroll-fade-in rounded-lg p-6 sm:p-8 flex items-start md:items-end flex-col justify-center z-10">
              <div class="w-[51px] h-3 bg-[#10b981] rounded-[51px] mb-6 sm:mb-8 md:mb-[50px]"></div>
              <p class="text-white text-base sm:text-[12px] md:text-[16px] lg:text-[20px] leading-relaxed">
                利用数字化技术，施工人员可以通过虚拟现实技术模拟施工过程，提前发现并解决可能存在的问题，确保施工质量。同时，数字化技术还可以实现施工过程的实时监控，确保施工标准的一致性。
              </p>
            </div>
          </div>

          <!-- 第四个：升级客户体验 - 图右文左 -->
          <div class="flex flex-col md:flex-row items-stretch relative md:-mt-[6%] scroll-fade-in-right">
            <!-- 左侧：深蓝色遮罩层（只有描述文字） -->
            <div class="w-full md:flex-4 md:min-w-[400px] scroll-fade-in flex-col rounded-lg p-6 sm:p-8 flex items-start order-2 md:order-1 justify-center">

              <div class="w-[51px] h-3 bg-[#10b981] rounded-[51px] mb-6 sm:mb-8 md:mb-[50px]"></div>
              <p class="text-white text-base sm:text-lg md:text-xl lg:text-2xl leading-relaxed">
                数字化技术能够提供更加个性化的家装方案，客户可以通过虚拟现实技术预览装修效果，参与到设计中，使装修过程更加透明，提升了客户的参与感和满意度。
              </p>
            </div>
            <!-- 右侧：图片（标题叠加在图片上） -->
            <div class="w-full md:flex-5 md:min-w-[400px] scroll-fade-in relative order-1 md:order-2">
              <img
                src="../../assets/img/jz_4.webp"
                alt="lbe"
                class="w-full h-[250px] sm:h-[300px] md:h-[400px] lg:h-[678px] object-cover transition-transform duration-1000 ease-in-out hover:scale-105"
              />
              <!-- 标题叠加在图片上 - 移动端显示在图片底部 -->
              <div
                class="absolute bottom-4 left-4 md:top-[103px] md:bottom-auto md:ml-[-16%] z-20 scroll-fade-in w-[calc(100%-2rem)] md:w-auto"
                style="background: linear-gradient(to right, #1D76D0 0%, rgba(29, 114, 205, 0) 100%);
                   padding: 7px 0px 5px 31px; border-radius: 46px;"
              >
                <div class="flex items-center gap-3 mb-[3px]">
                  <h3 class="text-white text-2xl sm:text-3xl md:text-2xl lg:text-4xl font-bold">
                    升级客户体验
                  </h3>
                </div>
                <div class="text-white/90 text-sm sm:text-base md:text-[20px] lg:text-[24px]">
                  UPGRADE THE CUSTOMER EXPERIENCE
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="custom-development w-full pt-8 sm:pt-12 md:pt-16 lg:pt-[68px] pb-8 sm:pb-12 md:pb-16 lg:pb-[130px]"
      :style="{ backgroundImage: `url(${boardBgImg})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }"
    >
      <div class="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-8">
        <div class="flex flex-col items-center">
          <!-- 标题 -->
          <img
            src="../../assets/img/jsnl.webp"
            alt="custom-development"
            class="mb-6 sm:mb-8 md:mb-10 lg:mb-[46px] w-full max-w-[100px] sm:max-w-[122px] md:max-w-[144px] lg:max-w-[265px]"
          >
          <!-- 技术图标区域 -->
          <div class="w-full max-w-[1200px]">
            <!-- 上方两个图标：左右分布 -->
            <div class="container m-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 sm:gap-6 lg:gap-0">
              <!-- 技术1：高精准定位技术（左上） -->
              <div class="flex flex-col sm:flex-row items-center justify-center min-h-[150px] sm:min-h-[200px] h-auto sm:h-[350px] mt-4 sm:mt-6 lg:mt-0">
                <div class="md:w-full sm:w-1/2 flex justify-center h-[150px] sm:h-[350px] scroll-fade-in-left">
                  <img
                    src="../../assets/img/c1.webp"
                    alt="高精准定位技术"
                    class="w-full h-full object-cover"
                  >
                </div>
                <div
                  class="flex flex-col h-full md:w-full sm:w-1/2 p-4 sm:p-[24px] justify-center scroll-fade-in-right"
                  style="background: rgba(3, 3, 3, 0.4);"
                >
                  <div class="text-white text-[16px] sm:text-[20px] md:text-[24px] font-bold mb-2">
                    高精准定位技术
                  </div>
                  <p class="text-white text-[12px] sm:text-[14px] md:text-[18px]">
                    High-Precision<br />Positioning Technology
                  </p>
                </div>
              </div>

              <!-- 技术2：低延迟、高帧率渲染技术（右上） -->
              <div class="flex flex-col sm:flex-row items-center justify-center min-h-[150px] sm:min-h-[200px] h-auto sm:h-[350px] mt-4 sm:mt-6 lg:mt-0">
                <div class="md:w-full sm:w-1/2 flex justify-center h-[150px] sm:h-[350px] scroll-fade-in-right">
                  <img
                    src="../../assets/img/c2.webp"
                    alt="低延迟、高帧率渲染技术"
                    class="w-full h-full object-cover"
                  >
                </div>
                <div
                  class="flex flex-col h-full md:w-full sm:w-1/2 p-4 sm:p-[24px] justify-center scroll-fade-in-left"
                  style="background: rgba(3, 3, 3, 0.4);"
                >
                  <div class="text-white text-[16px] sm:text-[20px] md:text-[24px] font-bold mb-2">
                    低延迟、高帧率渲染技术
                  </div>
                  <p class="text-white text-[12px] sm:text-[14px] md:text-[18px]">
                    Low-Latency, <br />High-Frame-Rate <br />Rendering Technology
                  </p>
                </div>
              </div>
            </div>

          </div>
          <!-- 技术3：多人实时互动协作技术（底部居中） -->
          <div class="flex flex-col sm:flex-row items-center justify-center min-h-[150px] sm:min-h-[200px] h-auto sm:h-[350px] mt-4 sm:mt-6 lg:mt-0 w-full lg:w-1/2 lg:mx-auto">
            <div class="w-full sm:w-1/2 flex justify-center h-[150px] sm:h-[350px] scroll-fade-in-left">
              <img
                src="../../assets/img/c3.webp"
                alt="多人实时互动协作技术"
                class="w-full h-full object-cover"
              >
            </div>
            <div
              class="flex flex-col h-full w-full sm:w-1/2 p-4 sm:p-[24px] justify-center scroll-fade-in-right"
              style="background: rgba(3, 3, 3, 0.4);"
            >
              <div class="text-white text-[16px] sm:text-[20px] md:text-[24px] font-bold mb-2">
                多人实时互动协作技术
              </div>
              <p class="text-white text-[12px] sm:text-[14px] md:text-[18px]">
                Real-Time Interactive<br />Collaboration Technology For <br />Multiple People
              </p>
            </div>
          </div>

        </div>

      </div>
    </div>

    <ContactUs />
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from "vue";
import ContactUs from "@/components/ContactUs.vue";
import boardBgImg from "@/assets/img/xrhousebg.webp";
const videoRef = ref<HTMLVideoElement | null>(null);

const skipFirstSecond = () => {
  if (videoRef.value) {
    videoRef.value.currentTime = 1.5;
  }
};

// 存储已触发动画的元素
const animatedElements = new Set<HTMLElement>();

// Intersection Observer 配置
const observerOptions: IntersectionObserverInit = {
  root: null,
  rootMargin: "0px",
  threshold: 0.1, // 当元素10%可见时触发
};

// 创建 Intersection Observer
let observer: IntersectionObserver | null = null;

onMounted(() => {
  // 创建 observer
  observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (
        entry.isIntersecting &&
        !animatedElements.has(entry.target as HTMLElement)
      ) {
        // 元素进入视口且未触发过动画
        const element = entry.target as HTMLElement;
        // 检查元素是否已经在视口中（初始可见）
        const rect = element.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

        if (isVisible) {
          // 如果元素已经在视口中，立即应用动画
          element.classList.add("fade-in-visible");
          animatedElements.add(element);
        } else {
          // 否则等待 observer 触发
          element.classList.add("fade-in-visible");
          animatedElements.add(element);
        }
      }
    });
  }, observerOptions);

  // 观察所有带有滚动动画类的元素
  const elements = document.querySelectorAll(
    ".scroll-fade-in, .scroll-fade-in-left, .scroll-fade-in-right"
  );
  elements.forEach((element) => {
    // 检查元素是否已经在视口中
    const rect = element.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

    if (isVisible && !animatedElements.has(element as HTMLElement)) {
      // 如果元素已经在视口中，立即应用动画
      (element as HTMLElement).classList.add("fade-in-visible");
      animatedElements.add(element as HTMLElement);
    } else if (observer) {
      // 否则开始观察
      observer.observe(element);
    }
  });
});

onBeforeUnmount(() => {
  if (observer) {
    observer.disconnect();
  }
});
</script>

<style scoped>
/* 滚动动画效果 - 小元素从底部飞入 */
.scroll-fade-in {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.scroll-fade-in.fade-in-visible {
  opacity: 1;
  transform: translateY(0);
}

/* 滚动动画效果 - 从左边飞入 */
.scroll-fade-in-left {
  opacity: 0;
  transform: translateX(-50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.scroll-fade-in-left.fade-in-visible {
  opacity: 1;
  transform: translateX(0);
}

/* 滚动动画效果 - 从右边飞入 */
.scroll-fade-in-right {
  opacity: 0;
  transform: translateX(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.scroll-fade-in-right.fade-in-visible {
  opacity: 1;
  transform: translateX(0);
}
</style>